import TablaValidateLicenseRow from "./rows/TablaValidateLicenseRow";
import AdminCard from "../cards/AdminCard";
import {
  VALIDATE_LICENSE_FIELDS,
  getFormattedAddress,
} from "../../../utils/configs/adminCardConfigs";

function TablaValidateLicense({ rows, onDecision }) {
  if (!rows || rows.length === 0) {
    return (
      <div className="note info">
        <b>No pending licenses to validate</b>
      </div>
    );
  }

  return (
    <div className="table-wrapper">
      <table className="table admin-table">
        <thead>
          <tr>
            <th className="col-address">Business Address</th>
            <th className="col-name">Firstname</th>
            <th className="col-name">Lastname</th>
            <th className="col-email">Email</th>
            <th className="col-phone">Phone</th>
            <th className="col-license">License Number</th>
            <th className="col-actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((item, idx) => (
            <TablaValidateLicenseRow
              key={idx}
              item={item}
              onDecision={onDecision}
            />
          ))}
        </tbody>
      </table>

      {/* Mobile friendly cards (shown via media queries) */}
      <div className="admin-validate-cards">
        {rows.map((item, idx) => {
          const p = item.provider || {};
          const address = getFormattedAddress(p.address);

          const actions = [
            {
              key: "accept",
              text: "Accept",
              icon: "check_circle",
              onClick: (data) => onDecision(p, "Approved", data.license),
              className: "btnAccept",
            },
            {
              key: "reject",
              text: "Reject",
              icon: "close",
              onClick: (data) => onDecision(p, "Rejected", data.license),
              className: "btnReject",
            },
          ];

          return (
            <AdminCard
              key={idx}
              data={{
                ...item,
                address: { title: "Business Address", value: address },
              }}
              fields={VALIDATE_LICENSE_FIELDS}
              actions={actions}
            />
          );
        })}
      </div>
    </div>
  );
}

export default TablaValidateLicense;
